import { toggleValue } from "common/utils/sets";

import SelectButton from "client/common/components/buttons/SelectButton";

import { SearchFilterOption } from "../types";

import styles from "../styles/SearchFilter.module.less";

type SearchFilterProps<T extends string | number | boolean> = {
  options: SearchFilterOption<T>[];
  value: T[];
  onChange: (val: T[]) => void;
};

const SearchFilter = <T extends string | number | boolean = number>({
  options,
  value,
  onChange,
}: SearchFilterProps<T>) => {
  const enabledValues = new Set(value);

  const onToggle = (val: T) => onChange([...toggleValue(value, val)]);

  return (
    <div className={styles.options}>
      {options.map((option) => (
        <SelectButton
          key={option.label}
          align="center"
          isActive={enabledValues.has(option.value)}
          onClick={() => onToggle(option.value)}
          renderContent={(props) => (
            <SelectButton.DefinitionContent
              {...props}
              label={option.label}
              description=""
              status={null}
            />
          )}
        />
      ))}
    </div>
  );
};

export default SearchFilter;
